// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectPaymentTerm  {
    _originalTypeClassName = "Loom.BO.ProjectPaymentTerm";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectPaymentTerm.translate = translateService;
}
this.Id = null;
this.PaymentDate = null;
this.Description = null;
this.Percentage = null;
this.Amount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
PaymentDate:any;
Description:any;
Percentage:any;
Amount:any;
Project:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeProjectPaymentTerms(oldValue, $this);
}
Domain.Project.addProjectPaymentTerms(value, $this);
}
}

static GetAmount($this: any): any{return Joove.Common.safeNumber($this?.Project?.EUContribution) * Joove.Common.safeNumber($this?.Percentage);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}